<template>
    € {{ new Intl.NumberFormat(locale, numberFormatOptions).format(value).replace("EUR", "").trim() }}
</template>

<script setup lang="ts">
// @ts-ignore
import {getConfigValue} from "@elements/config-utils";
// @ts-ignore
import {defineProps} from "vue";

const locale = getConfigValue('locale');

const numberFormatOptions: { currencyDisplay: string; style: string; currency: string } = {
  currencyDisplay: 'code',
  style: 'currency',
  currency: 'EUR',
};

const props = defineProps<{
    value: number
}>();

</script>